import App from "./pages/App.svelte";

const app = new App({
  target: document.body,
});

export default app;
